import {
  Box,
  Button,
  FormControl,
  Container,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import { CreateMappingValidationSchema } from "../../../utils/Validations";
import {
  postRequest,
  getRequestWithToken,
  putRequestWithToken,
} from "../../../utils/ApiRequests";
import { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../components/GlobalStateProvide/GlobalStateProvider";
import FocusError from "../../../components/FocusError/FocusError";
import ReusableLoader from "../../../components/ReusableLoader/ReusableLoader";
import BackBtn from "../../../components/backButton/BackBtn";
import { checkPermission } from "../../../utils/userPermissions";
import Unauthorized from "../../../components/unauthorized/Unauthorized";
import "./mapping.scss";

const CreateMapping = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [dataById, setDataById] = useState([]);
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(true);

  // OTP Verification States
  const [verificationStep, setVerificationStep] = useState('mobile');

  const [canCreate, setCanCreate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  const [canUpdate, setCanUpdate] = useState(true);
  const [canRead, setCanRead] = useState(true);
  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(true);
  const [regionData, setRegionData] = useState([]);
  const [formData, setFormData] = useState([]);

  const [initialValues, setInitialValues] = useState({

    region_id: "",
    form_id: "",
    phc: null,
    nearbyCharge: null,
    intelligenceFee: null,
    isVisibleToEmployer: false,
  });
  const [editForm, setEditForm] = useState(false);
  const { handleSnackBar } = useContext(GlobalContext);
  const scrollTargetRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = async (values, { resetForm }) => {
    setFormSubmitted(true);
    const formData = {
      form_id: values.form_id,
      region_id: values.region_id,
      phc: values.phc,
      nearbyCharge: values.nearbyCharge,
      intelligenceFee: values.intelligenceFee,
      isVisibleToEmployer: values.isVisibleToEmployer,
      isActive: true
    };
    try {
      let res;
      if (editForm) {
        // PUT request for update
        res = await putRequestWithToken(`admin/region-form-mappings/${dataById._id}`, formData);
      } else {
        // POST request for create
        res = await postRequest("admin/region-form-mappings", formData);
      }

      if (res.data.status === "Success" || res.data.success) {
        setFormSubmitted(false);
        handleSnackBar(true, res.data.msg || "Operation successful", "success");
        setTimeout(() => {
          navigate("/region-mapping");
        }, 1000);
        if (!editForm) {
          resetForm();
        }
      } else {
        setFormSubmitted(false);
        handleSnackBar(true, res.data.msg || "Operation failed", "error");
      }
    } catch (err) {
      setFormSubmitted(false);
      handleSnackBar(true, err?.response?.data?.msg || err.msg, "error");
    }
  };


  const checkPermissionFunc = () => {
    const resourceToUpdate = "Candidate";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate);
    setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    // console.log("hello")
    const checkAccesInArray = localStorage.getItem("resourceNames");
    // console.log("resourceNames : " + checkAccesInArray);
    setisAccess(checkAccesInArray);
    isIncludes();
  };

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("Candidate"));
  };

  const getAllRegions = async () => {
    try {

      let response = await getRequestWithToken(
        `/admin/regions?page=1&limit=100`
      );
      // setRowCount(response?.data?.data.totalCount);
      setRegionData(response?.data.data.regions);
      setShowLoader(false);

    } catch (error) {
      handleSnackBar(
        true,
        error?.response?.data?.msg || error?.message,
        "error"
      );
      setShowLoader(false);
    }
  };
  const getAllForms = async () => {
    try {

      let response = await getRequestWithToken(
        `/admin/dynamic-forms?page=1&limit=100`
      );
      // setRowCount(response?.data?.data.totalCount);
      setFormData(response?.data?.data?.forms);
      setShowLoader(false);

    } catch (error) {
      handleSnackBar(
        true,
        error?.response?.data?.msg || error?.message,
        "error"
      );
      setShowLoader(false);
    }
  };

  // Initial load effect - runs once on mount
  useEffect(() => {
    checkPermissionFunc();
    againCheckPermissions();
    getAllRegions();
    getAllForms();
  }, []);

  // Update isIncludesValue when isAccess changes
  useEffect(() => {
    if (isAccess) {
      setisIncludesValue(isAccess.includes("Candidate"));
    }
  }, [isAccess]);

  // Fetch candidate data when location state changes
  useEffect(() => {
    if (location.state?._id) {
      setDataById(location.state);
    } else {
      setShowLoader(false);
      setEditForm(false);

    }
  }, [location.state?._id]);

  // Map candidate data to form when dataById changes
  useEffect(() => {
    if (!dataById || Object.keys(dataById).length === 0) return;

    const {
      region_id = "",
      form_id = "",
      phc = null,
      intelligenceFee = null,
      nearbyCharge = null,
      isVisibleToEmployer = false,

    } = dataById;


    setInitialValues({
      region_id: region_id._id || "",
      form_id: form_id._id || "",
      phc: phc || 0,
      intelligenceFee: intelligenceFee || null,
      nearbyCharge: nearbyCharge || null,
      isVisibleToEmployer: isVisibleToEmployer || false,
    });
    setEditForm(true);
  }, [dataById]);



  return isIncludesValue ? (
    <>

      <Box className="create-candidates-section" ref={scrollTargetRef}>
        <Container>
          <Box className="create-candidates">
            <Box className="headingPlusBackBtn">
              <BackBtn />
              <h1 className="formHeadings" id="topEle">
                {editForm ? "Update Mapping" : "Create Mapping"}
              </h1>
            </Box>
            <Box className="create-candidates-form-wrapper">
              <Formik
                initialValues={initialValues}
                validationSchema={CreateMappingValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ errors, values, setFieldValue, resetForm }) => (
                  <Form className="create-candidates-form">
                    <Box className="backgroundStyle" sx={{ marginTop: "20px" }}>
                      <Grid
                        container
                        spacing={2}
                        className="cstmFormGridEmployer"
                      >


                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <label className="form-label" htmlFor="form_id">
                              Form/Role Name
                              <span className="must-fill-fields">*</span>
                            </label>
                            <FormControl name="form_id" fullWidth size="small">
                              {values.form_id === "" && (
                                <InputLabel shrink={false}>
                                  Select Role
                                </InputLabel>
                              )}
                              <Select
                                placeholder="Select Role"
                                name="form_id"
                                id="form_id"
                                disabled={editForm}
                                value={values.form_id || values.form_id._id}
                                onChange={(event) => {
                                  setFieldValue("form_id", event.target.value);
                                }}
                              >
                                {formData?.map((form) => (
                                  <MenuItem key={form?._id} value={form?._id}>
                                    {form.role}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            {errors.form_id && (
                              <Box className="form-error">
                                {errors.form_id}
                              </Box>
                            )}
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <label className="form-label" htmlFor="region_id">
                              Region Name
                              <span className="must-fill-fields">*</span>
                            </label>
                            <FormControl name="region_id" fullWidth size="small">
                              {values.region_id === "" && (
                                <InputLabel shrink={false}>
                                  Select Region
                                </InputLabel>
                              )}
                              <Select
                                placeholder="Select Region"
                                name="region_id"
                                id="region_id"
                                disabled={editForm}
                                value={values.region_id || values.region_id._id}
                                onChange={(event) => {
                                  setFieldValue("region_id", event.target.value);
                                }}
                              >
                                {regionData?.map((region) => (
                                  <MenuItem key={region?._id} value={region?._id}>
                                    {region.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            {errors.region_id && (
                              <Box className="form-error">
                                {errors.region_id}
                              </Box>
                            )}
                          </Box>
                        </Grid>



                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <label className="form-label" htmlFor="phc">
                              PHC per candidate
                              <span className="must-fill-fields">*</span>
                            </label>
                            <Field
                              id="phc"
                              type="number"
                              placeholder="Enter phc"
                              name="phc"
                              className="form-input"
                              maxLength={6}
                            />
                            {errors.phc && (
                              <Box className="form-error">
                                {errors.phc}
                              </Box>
                            )}
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control" sx={{ display: 'flex', alignItems: 'center', height: '100%', marginTop: '30px' }}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={values.isVisibleToEmployer}
                                  onChange={(event) => {
                                    setFieldValue("isVisibleToEmployer", event.target.checked);
                                  }}
                                  name="isVisibleToEmployer"
                                  color="primary"
                                />
                              }
                              label="Region Filter Visibility"
                              labelPlacement="start"
                              sx={{ marginLeft: 0, justifyContent: 'start', width: '100%' }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box className="backgroundStyle" >
                      <Typography variant="h6" sx={{ marginBottom: 2 }}>
                        Additional SNF Settings
                      </Typography>
                      <Grid
                        container
                        spacing={2}
                        className="cstmFormGridEmployer"
                      >
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <label className="form-label" htmlFor="intelligenceFee">
                              Intelligence Fee
                              <span className="must-fill-fields">*</span>
                            </label>
                            <Field
                              id="intelligenceFee"
                              type="number"
                              placeholder="Enter intelligence fee"
                              name="intelligenceFee"
                              className="form-input"
                              maxLength={6}
                            />
                            {errors.intelligenceFee && (
                              <Box className="form-error">
                                {errors.intelligenceFee}
                              </Box>
                            )}
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <label className="form-label" htmlFor="nearbyCharge">
                              Nearby Charge
                              <span className="must-fill-fields">*</span>
                            </label>
                            <Field
                              id="nearbyCharge"
                              type="number"
                              placeholder="Enter nearby charge"
                              name="nearbyCharge"
                              className="form-input"
                              maxLength={6}
                            />
                            {errors.nearbyCharge && (
                              <Box className="form-error">
                                {errors.nearbyCharge}
                              </Box>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box style={{ padding: "20px", display: "flex", gap: "15px", width: "100%", justifyContent: "flex-end" }}>
                      {/* <Button
                        type="button"
                        variant="outlined"

                        onClick={() => navigate("/region-mapping")}
                        disabled={formSubmitted}
                        style={{ minWidth: "200px", minHeight: "50px", borderColor: "#ff671f", color: "#ff671f" }}
                      >
                        Cancel
                      </Button> */}

                      <Link to='/region-mapping'>
                        <Button className="form-button"
                          variant="contained"
                          onClick={() => {
                            resetForm();
                          }}
                          color="error"
                          style={{ minWidth: "10px", minHeight: "30px" }}
                        >Cancel</Button>
                      </Link>
                      {/* <Button
                        type="submit"
                        variant="contained"
                        disabled={formSubmitted}
                        style={{ minWidth: "200px", minHeight: "50px", backgroundColor: "#ff671f" }}
                      >
                        {formSubmitted ? <ReusableLoader /> : editForm ? "Update Mapping" : "Create Mapping"}
                      </Button> */}

                      <Button className="form-button"
                        variant="contained"
                        type="submit"
                        color="success"
                        disabled={formSubmitted}
                        style={{ minWidth: "100px", minHeight: "30px" }}
                      >
                        {formSubmitted ? <ReusableLoader /> :
                          editForm ? "Update" : "Create"}
                      </Button>

                    </Box>
                    <FocusError handleSnackBar={handleSnackBar} />
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Container>
      </Box>

    </>
  ) : (
    <Unauthorized />
  );
};
export default CreateMapping;
